import { ReactNode, useEffect, useRef } from 'react';

import { cx } from '@libs/classnames';

import styles from './VideoPreview.module.css';

export type Props = {
  className?: string;
  stream?: MediaStream | null;
  // трек LiveKit подключается сам: так он знает размер и видимость элемента
  attach?: (el: HTMLVideoElement) => () => void;
  mirrored?: boolean;
  placeholder?: ReactNode;
};

export function VideoPreview({ className, stream, attach, mirrored, placeholder }: Props) {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;
    if (attach) return attach(video);
    video.srcObject = stream ?? null;
  }, [stream, attach]);

  return (
    <div className={cx(styles.preview, className, { [styles.is_mirrored]: mirrored })}>
      {stream || attach ? (
        <video ref={ref} className={styles.preview__video} autoPlay muted playsInline />
      ) : (
        <div className={styles.preview__placeholder}>{placeholder}</div>
      )}
    </div>
  );
}
